var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTooltip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "d76nhi5vda",
    d: "M10 0c5.523 0 10 4.477 10 10s-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0zm0 1.818c-4.519 0-8.182 3.663-8.182 8.182S5.481 18.182 10 18.182s8.182-3.663 8.182-8.182S14.519 1.818 10 1.818zm0 7.273c.502 0 .91.407.91.909v3.636c0 .502-.408.91-.91.91s-.91-.408-.91-.91V10c0-.502.408-.91.91-.91zm0-3.636l.115.006c.452.052.803.436.803.903 0 .502-.407.909-.909.909H10c-.502 0-.91-.407-.91-.91 0-.501.408-.908.91-.908z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-280.000000, -309.000000) translate(280.000000, 309.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "i30qmi81nb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d76nhi5vda"
  })), /*#__PURE__*/React.createElement("use", {
    fillRule: "nonzero",
    xlinkHref: "#d76nhi5vda"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#i30qmi81nb)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H24.545V26.364H0z",
    transform: "translate(-1.818182, -4.545455) translate(-0.000000, 0.000000)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTooltip);
export default __webpack_public_path__ + "static/media/Tooltip.5ff8f13eaf368e5fb75ace6798f0d5c4.svg";
export { ForwardRef as ReactComponent };